import "./ios-toggle.css";

/**
 * iPhone-style on/off toggle for boolean form fields.
 */
export default function IOSToggle({
    checked = false,
    onChange,
    disabled = false,
    id,
    label,
    description,
    className = ""
}) {
    return (
        <div className={`ios-toggle-field${className ? ` ${className}` : ""}`}>
            {(label || description) && (
                <div className="ios-toggle-copy">
                    {label && <span className="ios-toggle-label" id={id ? `${id}-label` : undefined}>{label}</span>}
                    {description && <span className="ios-toggle-description muted">{description}</span>}
                </div>
            )}
            <button
                type="button"
                id={id}
                role="switch"
                aria-checked={checked}
                aria-labelledby={label && id ? `${id}-label` : undefined}
                className={`ios-toggle${checked ? " is-on" : ""}`}
                disabled={disabled}
                onClick={() => onChange?.(!checked)}
            >
                <span className="ios-toggle-track" aria-hidden="true">
                    <span className="ios-toggle-knob" />
                </span>
            </button>
        </div>
    );
}
